import BasicLayout from '@/layouts/basic-layout'

const prefix = 'fin-receivable-'
export default {
  path: '/financial-manage/fin-receivable',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '应收管理-承'},
      component: () => import('@/pages/financial-manage/fin-receivable/index')
    },
    {
      path: 'detail-create',
      name: `${prefix}create`,
      auth: ['hidden'],
      meta: {title: '应收申请新增-承'},
      component: () => import('@/pages/financial-manage/fin-receivable/detail-create')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '应收申请编辑-承'},
      component: () => import('@/pages/financial-manage/fin-receivable/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '业主合同收付款情况详情-承'},
      component: () => import('@/pages/financial-manage/fin-receivable/detail-view')
    }
  ]
}
